import { ResponseService } from './response.service';
import { ReplaySubject } from 'rxjs/Rx';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ConversationsService {

    private openConversationsCount: ReplaySubject<number> = new ReplaySubject(1);

    constructor(
        private apiService: ApiService,
        private responseService: ResponseService
    ) { }

    /**
     * Pobiera ilość otwartych konwersacji uzytkownika
     */
    public getOpenConversationsCount() {
        this.apiService.get('/conversations/list/open/count').subscribe(
            (response) => {
                this.openConversationsCount.next(this.responseService.success(false, response, 'count'));
            },
            (error) => {
                this.responseService.error(error);
            }
        );
        return this.openConversationsCount;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/conversations.service.ts